'use client';
import Image from 'next/image';

const HowDoWeWork = ({ title, subtitle, videoImage, columns, brandLogos }) => {
  const firstRow = columns.slice(0, 3);
  const secondRow = columns.slice(3);

  return (
    <section className="bg-sky-100 py-10 md:py-20 lg:py-24">
      <div className="max-w-screen-xl mx-5 lg:mx-auto lg:px-20">
        {/* Header Section */}
        <div className="text-center mb-6 md:mb-10 lg:mb-14">
          <p className="font-semibold text-[#01c05f] text-base md:text-lg uppercase">
            {title}
          </p>
          <h2 className="font-semibold text-blue-800 my-3 mx-auto lg:w-2/3">
            {subtitle}
          </h2>
          <Image
            alt="Video Thumbnail"
            src={videoImage}
            className="ml-auto object-cover w-full rounded-xl"
            width={500}
            height={582}
          />
        </div>

        {/* First Row: 3 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {firstRow.map((item, index) => (
            <div
              key={index}
              className="p-6 bg-white shadow-md rounded-md text-center transform transition duration-300 hover:shadow-lg hover:scale-105"
            >
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                {item.title}
              </h3>
              <p className="text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Second Row: 2 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {secondRow.map((item, index) => (
            <div
              key={index}
              className="p-6 bg-white shadow-md rounded-md text-center transform transition duration-300 hover:shadow-lg hover:scale-105"
            >
              <h3 className="text-lg font-bold text-gray-800 mb-4">
                {item.title}
              </h3>
              <p className="text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Brand Logos */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 items-center justify-between opacity-60">
          {brandLogos.map((logo, index) => (
            <div key={index}>
              <img
                alt={logo.alt}
                src={logo.src}
                className="object-cover px-6"
                width={200}
                height={150}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowDoWeWork;
